export default __webpack_public_path__ + "static/Chevron_TCC22_Website_970x250-00c78038037f1bda5292ae931368839d.jpg";